import OrderDetailsDialog from "./orderDetailsDialog.container";

export default OrderDetailsDialog;
